module.exports = __webpack_public_path__ + "img/growcify-app-banner-9.4af14097.png";